import { showConfirm, showError } from '../../components/Messages';
import {
   buildQueryString,
   getEnderecoCompleto,
   updateState,
   rsaEncrypt,
   validarEndereco,
   validarTelefone,
} from '../../utils/Functions';
import { BaseController } from '../BaseController';
import btoa from 'btoa';

export default class EmpresaController extends BaseController {
   constructor(props) {
      super(props);
      this.name = 'EmpresaController';
      this.props = props.props;
   }

   antesDeInserir = () => {
      return new Promise((resolve) => {
         updateState(this.view, (state) => {
            state.cnpjParaNaoConsultar = null;
            resolve();
         });
      });
   };

   antesDeEditar = (formularioPadrao, empresa) => {
      return new Promise((resolve) => {
         updateState(this.view, (state) => {
            state.cnpjParaNaoConsultar = empresa.cnpj;
            resolve();
         });
      });
   };

   getTitulosDaTabela = () => {
      return [
         {
            titulo: this.lang.codigo,
            orderby: 'Id',
            className: 'codigo',
         },
         {
            titulo: this.lang.telaDeCadastroDeEmpresa.razaoSocial,
            width: '40%',
            orderby: null,
         },
         {
            titulo: this.lang.telaDeCadastroDeEmpresa.nomeFantasia,
            width: '40%',
            orderby: null,
         },
         { titulo: this.lang.telaDeCadastroDeEmpresa.cnpj, width: '20%', orderby: null },
      ];
   };

   getDadosDaTabela = (item) => {
      return [item.id, item.razaoSocial, item.nomeFantasia, item.cnpj];
   };

   getObjetoDeDados = () => {
      return new Promise((resolve, reject) => {
         let state = this.view.state;
         let item = state.itemSelecionado;

         if (!item.situacaoDoContrato) {
            showError(this.lang.telaDeCadastroDeEmpresa.mensagens.informeASituacaoDoContrato);
            reject();
            return;
         }

         if (!item.pais) {
            showError(this.lang.telaDeCadastroDeEmpresa.mensagens.informeOPaisDaEmpresa);
            reject();
            return;
         }

         if (!item.razaoSocial) {
            showError(this.lang.telaDeCadastroDeEmpresa.mensagens.informeARazaoSocialDaEmpresa);
            reject();
            return;
         }

         if (!item.nomeFantasia) {
            showError(this.lang.telaDeCadastroDeEmpresa.mensagens.informeONomeFantasiaDaEmpresa);
            reject();
            return;
         }

         if (item.razaoSocial.length > 100) {
            showError(this.lang.telaDeCadastroDeEmpresa.mensagens.nomeDaEmpresaExcedeOLimitede100Caracteres);
            reject();
            return;
         }

         if (!item.cnpj) {
            showError(this.lang.telaDeCadastroDeEmpresa.mensagens.informeOCnpj);
            reject();
            return;
         }

         if (!item.email) {
            showError(this.lang.telaDeCadastroDeEmpresa.mensagens.informeOEmail);
            reject();
            return;
         }

         if (!item.tipoDeContrato) {
            showError(this.lang.telaDeCadastroDeEmpresa.mensagens.informeOTipoDeContrato);
            reject();
            return;
         }

         this.api
            .get('/publickey')
            .then((publicKey) => {
               let senhaCriptografada = null;
               let novaSenha = null;
               if (item.senha) {
                  let blocks = item.senha.match(new RegExp('.{1,' + 64 + '}', 'g'));
                  for (let i = 0; i < blocks.length; i++) {
                     let buffer = rsaEncrypt(blocks[i], publicKey);
                     senhaCriptografada = senhaCriptografada ? Buffer.concat([senhaCriptografada, buffer]) : buffer;
                  }
                  novaSenha = btoa(senhaCriptografada);
               }
               var input = {
                  razaoSocial: item.razaoSocial,
                  cnpj: item.cnpj,
                  telefones: item.telefones,
                  email: item.email,
                  foto: item.foto && item.foto.id ? item.foto : null,
                  enderecos: item.enderecos,
                  quantidadeMaximaDeUsuarios: item.quantidadeMaximaDeUsuarios,
                  dataDeCadastro: item.dataDeCadastro ? item.dataDeCadastro : new Date(),
                  situacao: item.situacao ? item.situacao.id : 0,
                  situacaoDoContrato: item.situacaoDoContrato ? item.situacaoDoContrato.id : 0,
                  nomeFantasia: item.nomeFantasia,
                  novaSenha: novaSenha,
                  senhaAlterada: item.senhaAlterada,
                  enviarNovaSenhaPorEmail: item.enviarNovaSenhaPorEmail,
                  pais: item.pais,
                  tipoDeContrato: item.tipoDeContrato,
                  identificacaoDaInstalacao: item.identificacaoDaInstalacao
               };

               if (state.alterando) {
                  input.id = parseInt(item.id);
               }
               resolve(input);
            })
            .catch((e) => {
               console.error(e);
               reject();
            });
      });
   };

   consultarCep = () => {
      if (
         this.view.state.enderecoSelecionado.endereco.cep &&
         this.view.state.enderecoSelecionado.endereco.cep.length === 9 &&
         this.view.state.enderecoSelecionado.endereco.cep !== this.view.state.cepParaNaoConsultar
      ) {
         this.props.consultaDeCep.get(this.view.state.enderecoSelecionado.endereco.cep).then((resultViaCep) => {
            if (resultViaCep && resultViaCep.localidade && resultViaCep.uf) {
               let url =
                  '/cidade' +
                  buildQueryString(null, null, null, {
                     uf: resultViaCep.uf.toUpperCase(),
                     localidade: resultViaCep.localidade.toUpperCase(),
                  });
               this.props.api
                  .getAll(url, false)
                  .then((result) => {
                     if (result.count === 1) {
                        let enderecoEmEdicao = { endereco: {} };
                        enderecoEmEdicao.cep = this.view.state.enderecoSelecionado.endereco.cep;
                        enderecoEmEdicao.logradouro = resultViaCep.logradouro
                           ? resultViaCep.logradouro.toUpperCase()
                           : null;
                        enderecoEmEdicao.bairro = resultViaCep.bairro ? resultViaCep.bairro.toUpperCase() : null;
                        enderecoEmEdicao.cidade = result.items[0];

                        updateState(this.view, (state) => {
                           state.enderecoSelecionado.endereco.logradouro = enderecoEmEdicao.logradouro;
                           state.enderecoSelecionado.endereco.bairro = enderecoEmEdicao.bairro;
                           state.enderecoSelecionado.endereco.cidade = enderecoEmEdicao.cidade;
                           state.mostrarEndereco = false;
                           state.cepParaNaoConsultar = this.view.state.enderecoSelecionado.endereco.cep;
                        }).then(() => {
                           updateState(this.view, (state) => {
                              state.mostrarEndereco = true;
                           });
                        });
                     }
                  })
                  .catch(() => {});
            }
         });
      }
   };

   inserirEndereco = () => {
      return new Promise((resolve, reject) => {
         if (!validarEndereco(true, this.view.state.enderecoSelecionado.endereco, this.lang, reject)) {
            return;
         }

         let endereco = {
            logradouro: this.view.state.enderecoSelecionado.endereco.logradouro,
            numero: this.view.state.enderecoSelecionado.endereco.numero,
            complemento: this.view.state.enderecoSelecionado.endereco.complemento,
            bairro: this.view.state.enderecoSelecionado.endereco.bairro,
            cep: this.view.state.enderecoSelecionado.endereco.cep,
            cidade: this.view.state.enderecoSelecionado.endereco.cidade,
            pais: this.view.state.enderecoSelecionado.endereco.pais,
            linha1: this.view.state.enderecoSelecionado.endereco.linha1,
            linha2: this.view.state.enderecoSelecionado.endereco.linha2,
            linha3: this.view.state.enderecoSelecionado.endereco.linha3,
         };

         endereco.enderecoCompleto = getEnderecoCompleto(endereco);

         updateState(this.view, (state) => {
            if (!state.itemSelecionado.enderecos) {
               state.itemSelecionado.enderecos = [];
            }
            state.itemSelecionado.enderecos.push({
               endereco,
            });
         }).then(() => resolve());
      });
   };

   alterarEndereco = (index) => {
      return new Promise((resolve, reject) => {
         if (!validarEndereco(true, this.view.state.enderecoSelecionado.endereco, this.lang, reject)) {
            return;
         }

         updateState(this.view, (state) => {
            state.itemSelecionado.enderecos[index].endereco.logradouro = state.enderecoSelecionado.endereco.logradouro;
            state.itemSelecionado.enderecos[index].endereco.numero = state.enderecoSelecionado.endereco.numero;
            state.itemSelecionado.enderecos[index].endereco.complemento =
               state.enderecoSelecionado.endereco.complemento;
            state.itemSelecionado.enderecos[index].endereco.bairro = state.enderecoSelecionado.endereco.bairro;
            state.itemSelecionado.enderecos[index].endereco.cep = state.enderecoSelecionado.endereco.cep;
            state.itemSelecionado.enderecos[index].endereco.cidade = state.enderecoSelecionado.endereco.cidade;
            state.itemSelecionado.enderecos[index].endereco.pais = state.enderecoSelecionado.endereco.pais;
            state.itemSelecionado.enderecos[index].endereco.linha1 = state.enderecoSelecionado.endereco.linha1;
            state.itemSelecionado.enderecos[index].endereco.linha2 = state.enderecoSelecionado.endereco.linha2;
            state.itemSelecionado.enderecos[index].endereco.linha3 = state.enderecoSelecionado.endereco.linha3;
            state.itemSelecionado.enderecos[index].endereco.enderecoCompleto = getEnderecoCompleto(
               state.itemSelecionado.enderecos[index].endereco
            );
         }).then(() => resolve());
      });
   };

   inserirTelefone = () => {
      return new Promise((resolve, reject) => {
         if (!validarTelefone('+55', this.view.state.telefoneSelecionado, this.lang, reject)) {
            return;
         }

         updateState(this.view, (state) => {
            if (!state.itemSelecionado.telefones) {
               state.itemSelecionado.telefones = [];
            }
            state.itemSelecionado.telefones.push({
               pais: this.view.state.telefoneSelecionado.pais,
               ddd: this.view.state.telefoneSelecionado.ddd,
               numero: this.view.state.telefoneSelecionado.numero,
               temWhatsApp: this.view.state.telefoneSelecionado.temWhatsApp ? true : false,
            });
         }).then(() => resolve());
      });
   };

   alterarTelefone = (index) => {
      return new Promise((resolve, reject) => {
         if (!validarTelefone('+55', this.view.state.telefoneSelecionado, this.lang, reject)) {
            return;
         }

         updateState(this.view, (state) => {
            state.itemSelecionado.telefones[index].pais = this.view.state.telefoneSelecionado.pais;
            state.itemSelecionado.telefones[index].ddd = this.view.state.telefoneSelecionado.ddd;
            state.itemSelecionado.telefones[index].numero = this.view.state.telefoneSelecionado.numero;
            state.itemSelecionado.telefones[index].temWhatsApp = this.view.state.telefoneSelecionado.temWhatsApp;
         }).then(() => resolve());
      });
   };

   verificarSeCnpjJaExiste = () => {
      let item = this.view.state.itemSelecionado;
      if (item && item.cnpj && item.cnpj.length === 18 && item.cnpj !== this.view.state.cnpjParaNaoConsultar) {
         this.props.api
            .getAll(
               this.view.state.url +
                  buildQueryString(null, null, null, {
                     cnpj: this.view.state.itemSelecionado.cnpj,
                  })
            )
            .then((result) => {
               if (result && result.count > 0) {
                  let empresa = result.items[0];
                  let mensagem = this.lang.telaDeCadastroDeEmpresa.empresaJaEstaCadastradaDesejaVisualizarOCadastro;
                  showConfirm(
                     mensagem,
                     () => {
                        updateState(this.view, (state) => {
                           state.incluindo = false;
                           state.alterando = false;
                        }).then(() => this.view.editar(empresa));
                     },
                     () => {
                        updateState(this.view, (state) => {
                           state.cnpjParaNaoConsultar = item.cnpj;
                        });
                     },
                     this.lang.sim,
                     this.lang.nao
                  );
               } else {
                  updateState(this.view, (state) => {
                     state.cnpjParaNaoConsultar = item.cnpj;
                  });
               }
            });
      }
   };
}
